import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { TaxiParada } from '@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-parada.entity';
import { TaxiParadaSearch } from 'app/services/mob/taxi-parada.search';
import { TaxiParadaService } from 'app/services/mob/taxi-parada.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';

@Component({
  selector: 'dropdown-numero-ordem',
  templateUrl: './dropdown-numero-ordem.component.html',
  styleUrls: ['./dropdown-numero-ordem.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownNumeroOrdemComponent implements OnInit {

  paradas: TaxiParada[];
  formGroup: FormGroup;
  filtros: TaxiParadaSearch = new TaxiParadaSearch();

  constructor(
    public _taxiParadaService: TaxiParadaService,
    private _dialogFactory: DialogFactory,
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.get('cdPonto').valueChanges.subscribe(async cdPonto => {
      this.filtros.cdPonto = cdPonto;
      await this.load()
    });
  }

  ngAfterViewInit(){
    this.formGroup.get('cdParada').valueChanges.subscribe(cdParada => {
      if(!this.paradas) return;
      
      const parada: TaxiParada = this.paradas.find(taxiParada => taxiParada.cdParada = cdParada);
      this.formGroup.get('nrParada').setValue(parada.nrParada);
    })
  }
  
  async load() {
    try {
      this.paradas = await this._taxiParadaService.find(new TaxiParadaSearch(this.filtros));
    }
    catch (responseError) {
      this._dialogFactory.snack('Carregamento de dados falhou.', 'OK', DialogFactory.SNACK_WARNING);
    }
  }

  selecionarParada(cdParada: number) {
    this.formGroup.get('cdParada').setValue(cdParada, { emitEvent: false });
  }

}
